import {
  Component,
  ChangeDetectionStrategy,
  Inject,
  AfterViewInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable, of } from 'rxjs';

import { StaticMessage } from '@shared/enums';
import { BaseDialogComponent } from '@shared/models/component';
import { Client } from '@shared/models';

@UntilDestroy()
@Component({
  selector: 'app-client-picker-dialog',
  templateUrl: './client-picker-dialog.component.html',
  styleUrls: ['./client-picker-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectClientDialogComponent
  extends BaseDialogComponent
  implements AfterViewInit
{
  StaticMessage = StaticMessage;

  selectedClientId: string[];
  initialSelection: string;

  constructor(
    protected dialogRef: MatDialogRef<SelectClientDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { selectedClientId: string; clients: Client[] }
  ) {
    super();
    this.selectedClientId = [data.selectedClientId];
    this.initialSelection = data.selectedClientId;
  }

  ngAfterViewInit(): void {
    const curSelectedElement = document.getElementsByClassName(
      'selectionItem selectedMenuItem'
    )[0] as HTMLElement;

    curSelectedElement?.scrollIntoView({ block: 'start' });
  }

  canDeactivate(): boolean | Observable<boolean> {
    return true;
  }

  save(): Observable<boolean> {
    this.onDone();
    return of(false);
  }

  trackClient(_index: number, client: Client): string {
    return client?.id;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  protected activateComponent(): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  protected deactivateComponent(): void {}

  private onDone(): void {
    const selectedClientId = this.selectedClientId[0];
    // If the selected client ID is the same as the initial one, close the dialog without returning a value
    if (selectedClientId === this.data.selectedClientId) {
      this.dialogRef.close();
      return;
    }

    this.dialogRef.close(selectedClientId);
  }
}
